import React from "react";
import { useCuttingPlanStore } from "../../../../stores/cuttingPlanStore";
import { useTranslation } from "react-i18next";
import { Container, Table } from "react-bootstrap";

const RebarSolutionOptions = () => {
    const { i18n, t } = useTranslation();

    const resultOptions = useCuttingPlanStore(state => state.cuttingPlanInformation);

    // Helper function to format seconds to "X hour Y min Z seconds"
    function formatSeconds(seconds) {
        seconds = Math.floor(seconds);
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        let parts = [];
        if (h > 0) parts.push(`${h} ${t("saat")}`);
        if (m > 0) parts.push(`${m} ${t("dakika")}`);
        if (s > 0 || parts.length === 0) parts.push(`${s} ${t("saniye")}`);
        return parts.join(" ");
    }

    return (
        <Container fluid className='border border-top-0 p-3' style={{ backgroundColor: 'white' }}>

            <Container className="border shadow-sm p-4">
                <Table>
                    <tbody>
                        <tr>
                            <th scope="row" style={{ width: '50%' }}>{t("Kesim Planı")}</th>
                            <td style={{ width: '50%' }}>{resultOptions.cpName}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Proje")}</th>
                            <td><a href={`/project-info/${resultOptions.projectId}`} target='_blank'>{`${resultOptions.projectName} (${resultOptions.projectId})`}</a></td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Kullanıcı")}</th>
                            <td>{resultOptions.projectUser}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Katlar")}</th>
                            <td>{resultOptions.floors}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Çaplar")}</th>
                            <td>{resultOptions.diameters}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Bindirme Oranı")}</th>
                            <td>{resultOptions.projectOverlapRatio}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Elde Kalacak En Kısa Fire")}</th>
                            <td>{resultOptions.minOutageLength}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Katlar Kendi Arasında mı Çözüldü?")}</th>
                            <td>{resultOptions.solveFloorsSeparately ? t("Evet") : t("Hayır")}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Oluşturma Zamanı")}</th>
                            <td>{resultOptions.creationTime.toLocaleString(i18n.language)}</td>
                        </tr>
                        <tr>
                            <th scope="row">{t("Toplam Çözüm Süresi")}</th>
                            <td>{formatSeconds(resultOptions.totalExecutionTime)}</td>
                        </tr>

                    </tbody>

                </Table>
            </Container>
            <Container className="border shadow-sm my-4 p-4">
                <Table>
                    <thead>
                        <tr>
                            <th>{t("Çap")}</th>
                            <th>{t("Çözüm Süresi")}</th>
                            <th>{t("Hızlı Çözüm")}</th>
                            <th>{t("Yerine Kullanım")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultOptions.diameterOptions.map((diameterOption, index) => (
                            <tr key={index}>
                                <th>{diameterOption.diameter}</th>
                                <td>{formatSeconds(diameterOption.executionTime)}</td>
                                <td>{diameterOption.usePartitions ? t("Evet") : t("Hayır")}</td>
                                <td>{diameterOption.useSubstitutes ? t("Evet") : t("Hayır")}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </Container>
    )
};

export default RebarSolutionOptions;